import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";

const background_color_gray = "#f9fafb";
const background_color_default = "#93a9bd";
const background_color_error = "#d5483eb8";
const color_error = "#D92D20";
const color_primary = getBrandCustom("primaryColor", "#308CDB");
const color_secondary = getBrandCustom("darkPrimaryColor", "#38CFC4");

const styles = makeStyles((theme) => ({
  modalSection: {
    width: "100%",
    position: "relative",
    padding: 0,
  },
  modalSectionHeader: {
    padding: "10px 16px",
    borderRadius: 8,
    width: "100%",
    backgroundColor: "#F9FAFB",
    zIndex: 99,
    "& .steps": {
      display: "flex",
      gap: 88,
      listStyle: "none",
      padding: 0,
      margin: 0,
      "& .valid": {
        cursor: "pointer",
      },
      "& .step": {
        font: "700 16px/24px Manrope",
        color: background_color_default,
        display: "flex",
        alignItems: "center",
        position: "relative",
        "&:not(:last-child):after": {
          content: '""',
          position: "absolute",
          left: "calc(100% + 25px)",
          width: 40,
          border: "1px dashed",
        },

        "& > span": {
          font: "700 12px/18px Manrope",
          marginRight: 15,
          color: "#fff",
          borderRadius: "50%",
          padding: "3px 9px",
          background: background_color_default,
        },
        "&.withCursor": {
          cursor: "pointer",
        },
        "&.error": {
          color: `${color_error} !important`,
          "& > span": {
            backgroundColor: `${background_color_error} !important`,
          },
        },
        "&.active": {
          color: color_primary,
          "& > span": {
            backgroundColor: `${color_primary} !important`,
          },
        },
        "&.concluded": {
          color: color_secondary,
          "& > span": {
            backgroundColor: `${color_secondary} !important`,
          },
          "&:not(:last-child):after": {
            border: "1px solid",
          },
        },
      },
    },
  },
  modalSectionBody: {
    marginTop: 24,
  },
  required: {
    color: color_error,
  },
}));

export default styles;
